// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"6605fedf","231":"6605fedf"}[chunkId] + ".chunk.css";
};